// Color palette for distinct elements
// See: https://godsnotwheregodsnot.blogspot.com/2012/09/color-distribution-methodology.html
// RGB
const DISTINCT_COLORS = [
  [213, 255, 0],
  [1, 0, 103],
  [255, 0, 86],
  [158, 0, 142],
  [14, 76, 161],
  [0, 95, 57],
  [0, 255, 0],
  [149, 0, 58],
  [255, 147, 126],
  [164, 36, 0],
  [0, 21, 68],
  [145, 208, 203],
  [98, 14, 0],
  [107, 104, 130],
  [0, 0, 255],
  [0, 125, 181],
  [106, 130, 108],
  [0, 174, 126],
  [194, 140, 159],
  [190, 153, 112],
  [0, 143, 156],
  [95, 173, 78],
  [1, 0, 103],
  [255, 0, 0],
  [255, 0, 246],
  [255, 2, 157],
  [104, 61, 59],
  [255, 116, 163],
  [150, 138, 232],
  [152, 255, 82],
  [167, 87, 64],
  [1, 255, 254],
];
export default DISTINCT_COLORS;
